/** declare only http service related requests */

import { HttpTokens, GetLegalHistory } from '@/src/types';
import { AxiosService } from '@/utils/axios';
import { AxiosResponse } from 'axios';
import { paramsQueryString } from '@/utils/index';
import { DEFAULT_HTTP_TIMEOUT } from '../..';
/**
 * @description Get /legal list
 * @param prefix only partial url, base url already prefixed
 * @param {boolean?} hardRejection when soft error is enabled it will return response from .then, and not catch it again, just so you know
 */
export const LegalHistoryGet = (prefix: string = 'legal/history', id: string, tokens: HttpTokens, hardRejection = true): Promise<GetLegalHistory> => {
  const instance = new AxiosService({ method: 'get', timeout: DEFAULT_HTTP_TIMEOUT, apiRef: prefix, proxyType: 'LOCAL_PROXY' }, true, hardRejection);

  const config = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      ...(tokens.jwt ? { Authorization: 'Bearer ' + tokens.jwt } : {}),
    },
  };

  const queryUri = paramsQueryString(`${prefix}/${id}`, {});

  return instance.client
    .get(queryUri, config)
    .then((d: AxiosResponse<GetLegalHistory>) => {
      return d.data;
    })
    .catch(instance.defaultHandleError) as Promise<GetLegalHistory>;
};
